import {gsap} from "gsap";

import {ScrollTrigger} from "gsap/ScrollTrigger";
import Swiper from "swiper";
import {Navigation} from "swiper/modules";



export const ViewPage = {
    namespace: 'page',
    beforeEnter(data) {

    },
    afterLeave() {



    },
    afterEnter() {

       document.querySelector('.header').classList.add('inverted');



       if (document.querySelectorAll('.single-case__swiper').length>0) {



           const swiperNav = new Swiper('.single-case__swiper', {
               slidesPerView: 1,
               modules: [Navigation],
               navigation: {
                   nextEl: '.swiper-button-next',
                   prevEl: '.swiper-button-prev',
               },
           });

       }

    }
}
